import { call, put, takeLatest, select } from "redux-saga/effects"
import { actionTypes } from "../actions"
import produce from "immer"
import trackEvent from "../../utils/webTrack/trackEvent"
import { TrackProps } from "../../utils/selector"
export let webTrackSagas = [takeLatest(actionTypes.WEB_TRACK_EVENT, trackUserEvent)]

const initialState = {}
export default (state = initialState, action) => produce(state, (draft) => {})

function* trackUserEvent({ payload: { eventType } }) {
  log("Tract Event Start")
  try {
    const trackProps = yield select(TrackProps)
    yield call(trackEvent, eventType, trackProps)
  } catch (err) {
    log(`Error: ${err}`)
  }
  log("Tract Event End")
}

function log(text) {
  console.log("%c WebTrack ", "color: white; background-color: #58595b", text)
}
